export const nameValidate = {
  validate: /^[a-z,\u4E00-\u9FA5,0-9,A-Z,-_@#.]{2,64}$/,
  tips: "2-64个字符组成，支持中文，字母，数字，以及-_@#."
}

export const phoneValidate = {
  validate: /^1[3|4|5|6|7|8|9]\d{9}$/,
  tips: "请输入正确的手机号码"
}
